<template>
    <div class="d-flex flex-column">
        <b-table :per-page="agendamentosPorPagina" :current-page="paginaAtualTabelaTableAgendamentoUsuario" striped hover :items="agendamentos" :fields="fields" show-empty :responsive="true" :busy="carregando">
                <template #empty >
                	<div class="d-flex">
                    	<span class="mx-auto">
                        	Nenhum Registro Encontrado
                    	</span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
				<template #cell(status)="data">
					<div class="d-flex justify-content-start align-items-center gap-sm">
						<font-awesome-icon :icon="['fas', 'circle']" :class="selecionaCorSituacaoAgendamento(data.item.situacao)"/>
						<span>
							{{ data.item.situacao }}
						</span>
					</div>
				</template>
				<template #cell(dataEHoraConsulta)="data">
					<div class="d-flex w-100">
						<span v-if="data.item.dataConsulta">
							{{ data.item.dataConsulta }}
						</span>
						<span class="mx-auto" v-else>
							-
						</span>
					</div>
				</template>
            </b-table>
            <b-pagination class="mx-auto" v-model="paginaAtualTabelaTableAgendamentoUsuario" :total-rows="numeroDeLinhasTableAgendamentoUsuario" :per-page="agendamentosPorPagina"></b-pagination>
    </div>
</template>


<script>
import AgendamentoService from "../../service/AgendamentoService.js";

export default{
	name: "TableAgendamentoUsuario",
	data() {
		return {
			carregando: false,
			agendamentos: [
			],
			fields: [
				{ label: "#", key: "index" },
			 	{ label: "Funcionário", key: "funcionario" },
			 	{ label: "Cargo", key: "cargo" },
			 	{ label: "Exame", key: "tipoExame" },
				{ label: "Data Do Agendamento", key: "dataInicio" },
				{ label: "Status", key: "status" },
				{ label: "Data/Hora da Consulta", key: "dataEHoraConsulta" },
			],
			agendamentosPorPagina: 5,
			numeroDeLinhasTableAgendamentoUsuario: 0,
			paginaAtualTabelaTableAgendamentoUsuario: 1,
		};
	},
	created() {
		this.consultarPorUsuario();
	},
	methods: {
		selecionaCorSituacaoAgendamento(situacao) {
			switch (situacao) {
			case "Agendado":
				return "statusAgendado";
			case "Aguardando":
				return "statusAguardando";

			case "Cancelado":
				return "statusCancelado";
			default:
				return "";
			}
		},
		consultarPorUsuario() {
			this.carregando = true;
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			AgendamentoService.consultarPorUsuario(usuarioLogado.id)
				.then((res) => {
					this.agendamentos = res.data;
					this.numeroDeLinhasTableAgendamentoUsuario = this.agendamentos.length;
				}).catch(err => console.log(err))
				.finally(() => {
					this.carregando = false;
				});
		},
	},
};
</script>

<style>
.statusAgendado{
	color: rgb(82, 172, 41) !important;
}

.statusAguardando{
	color: rgb(233, 188, 63) !important;

}
.statusCancelado{
	color: rgb(172, 41, 41) !important;
}</style>



// WEBPACK FOOTER //
// src/components/Agendamento/TableAgendamentosUsuario.vue